module.exports = __webpack_public_path__ + "static/media/image30.3efc16d6.jpeg";